module.exports = __webpack_public_path__ + "img/high-school-teacher-system.db6345e2.png";